import {combineReducers} from 'redux'

import connectivityReducer, {ConnectivityReducer as CR} from './connectivityReducer'
import mainReducer, {MainReducer as MR} from './mainReducer'
import notificationsReducer, {NotificationReducer as NR} from './notificationsReducer'
import userReducer, {UserReducer as UR} from './userReducer'

const rootReducer = combineReducers({
  mainReducer,
  notificationsReducer,
  userReducer,
  connectivityReducer,
})

// export type RootState = ReturnType<typeof rootReducer>
export interface RootState {
  mainReducer: MR
  userReducer: UR
  notificationsReducer: NR
  connectivityReducer: CR
}

export type MainReducer = MR
export type UserReducer = UR
export type NotificationReducer = NR
export type ConnectivityReducer = CR

export default rootReducer
